import React, { useContext } from 'react';
import { Checkbox, Col, Divider, message, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import useTradeStore from '../../hooks/trade/tradeStore';
import BigNumber from 'bignumber.js';
import API from '../../../utils/api';
import { useToken } from '@app/hooks';
import { toast } from 'react-toastify';
import { useOrderBook } from '../../hooks/trade/orderBook';
import { useTradePosition } from '../../hooks/trade/tradePosition';
import { useTradeSetting } from '../../hooks/trade/tradeSetting';
import { useTradeModalStore } from '../../hooks/trade/modalStore';
import { useIndexPrice } from '../../hooks/trade/indexprice';
import { ThemeContext } from '@/theme/ThemeProvider.tsx';
import { useDisableScroll } from '@utils/useDisableScroll.tsx';

import { useCiTradeWebSocketStore } from '../../hooks/ciTradeWebsocketStore.ts';
import usePercentageStore from '@/hooks/trade/percentageStore';
import { USER_LOG_TYPE, useUserLogger } from '@/app/hooks/userLogger';
interface IProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  long_short: string;
  orderId: number | null;
  rawOrderPrice: number;
  orderItem: any;
}

const EditCheckPositionModal = ({ open, setOpen, long_short, orderId, rawOrderPrice, orderItem }: IProps) => {
  const { t } = useTranslation();
  const { data: token } = useToken();
  const { data: tradeStore } = useTradeStore();
  const { textw } = useContext(ThemeContext).theme.COLORS;

  const { getPrice } = useIndexPrice(tradeStore?.ep_id);
  const { data: tradeModalStore, mutate: mutateTradeModalStore } =
    useTradeModalStore();
  const { data: tradeSetting } = useTradeSetting(tradeStore?.ep_id);
  const { mutate: mutateOrderBook } = useOrderBook(tradeStore?.ep_id);
  const { mutateUserLog, getOrderLog } = useUserLogger();  
  const { mutate: mutatePosition } = useTradePosition();
  const main = tradeStore?.pairs?.split('/')[0];
  const currency = tradeStore?.pairs?.split('/')[1];

  //const tradeData = useBinanceWebSocketStore((s) => s.tradeData);
  const globalPercentage = usePercentageStore((state) => state.percentage);

  const currentMarketPrice = useCiTradeWebSocketStore((s) => s.tradePrice);

  const sendOrder = async () => {

    if (!orderItem?.amount)
      return message.error(t('pleaseFillAllFields') + '');

    // if (tradeStore?.tpsl) {
    //   if (isNaN(tradeStore?.tp) || isNaN(tradeStore?.sl)) {
    //     return message.error('CHECK TP/SL');
    //   }
    // }


    
    // 지정가 주문 여부 확인
    const isLimitOrder =
      orderItem?.limit_market?.toUpperCase() == 'L' ||
      orderItem?.limit_market?.toUpperCase() == 'LIMIT';
    
    // 최종 주문 타입 결정
    let finalOrderType = isLimitOrder ? 'L' : 'M';
    
    if (isLimitOrder) {
      // 주문 가격과 현재 가격 비교
      const orderPrice = Number(rawOrderPrice);
      
      // 불리한 가격인지 확인
      const isPriceUnfavorable = 
        (long_short === 'L' && Number(orderPrice) > Number(currentMarketPrice)) || // 매수인데 지정가가 시장가보다 높음
        (long_short === 'S' && Number(orderPrice) < Number(currentMarketPrice));   // 매도인데 지정가가 시장가보다 낮음
      
      // 불리한 가격이면 시장가로 전환
      if (isPriceUnfavorable) {
        finalOrderType = 'M';
        // message.warning('불리한 가격으로 시장가 전환됨');
      }
    }



    const orderParams = {
      order_id: orderId,
      price: rawOrderPrice
    }

    const result = await API.put('/trade/order', '' + token, orderParams);
    //mutateStore({ ...tradeStore, order_amount: 0 })

    if (result.result.success) {
      // mutateUserLog({
      //   log : getOrderLog(orderParams, USER_LOG_TYPE.ORDER_OPEN),
      //   data : orderParams,
      // })
      mutateOrderBook();
      mutatePosition();

      setTimeout(() => {
        mutateOrderBook();
        mutatePosition(null);
      }, 500);

      toast(t('ordersuccess') + '', {
        type: 'success',
        delay: 150,
      });
    } else {
      if (result?.result?.message == 'ERROR_MAXAMOUNT') {
        toast(
          t('ERROR_MAXAMOUNT') +
            ' / MAX AMOUNT : ' +
            BigNumber(result?.result?.max).toFormat(3),
          {
            type: 'error',
          }
        );
      } else {
        toast(t(result?.result?.message + '') + '', {
          type: 'error',
        });
      }
    }
  };

  let margin = new BigNumber(orderItem?.amount * orderItem?.leverage)
    .multipliedBy(
      orderItem?.limit_market === 'M'
        ? currentMarketPrice ?? 0
        : rawOrderPrice ?? 0
    )
    .dividedBy(orderItem?.leverage)
    .toFormat(4);

  if (tradeStore?.main_sub == 'S') {
    margin = new BigNumber(orderItem?.amount * orderItem?.leverage)
      .dividedBy(orderItem?.leverage)
      .toFormat(3);
  }

  useDisableScroll(open);

  const handleTouchMove = (e) => {
    e.stopPropagation();
  };

  return (
    <Modal
      className={'custom-modal'}
      open={open}
      title={t('ordercheck') + ''}
      onCancel={() => {
        setOpen(false);
      }}
      onOk={() => {
        sendOrder();
        setOpen(false);
      }}
      cancelText={t('cancel')}
      okText={t('confirm')}
    >
      <div onTouchMove={handleTouchMove}>
      <Divider />
      <Row style={{ borderBottom: '1px solid #efefef', padding: '5px 0' }}>
        <Col span={12}>{t('pairs')}</Col>
        <Col span={12} style={{ fontWeight: 'bold' }}>
          {tradeStore?.pairs}
        </Col>
      </Row>
      <Row style={{ borderBottom: '1px solid #efefef', padding: '5px 0' }}>
        <Col span={12}>{t('price')}</Col>
        <Col span={12} style={{ fontWeight: 'bold' }}>
          {tradeStore?.limit_market == 'M'
            ? t('market')
            : rawOrderPrice}
        </Col>
      </Row>
      <Row style={{ borderBottom: '1px solid #efefef', padding: '5px 0' }}>
        <Col span={12}>{t('filledType')}</Col>
        <Col span={12} style={{ fontWeight: 'bold' }}>
          {long_short == 'L' ? t('long') : t('short')}
        </Col>
      </Row>
      <Row style={{ borderBottom: '1px solid #efefef', padding: '5px 0' }}>
        <Col span={12}>{t('amount')}</Col>
        <Col span={12} style={{ fontWeight: 'bold' }}>
          {orderItem?.amount * orderItem?.leverage}{' '}
          {orderItem?.main_sub == 'S' ? currency : main}
        </Col>
      </Row>
      <Row style={{ borderBottom: '1px solid #efefef', padding: '5px 0' }}>
        <Col span={12}>{t('leverage')}</Col>
        <Col span={12} style={{ fontWeight: 'bold' }}>
          {t(orderItem?.cross_iso == 'C' ? 'cross' : 'iso')}{' '}
          {orderItem?.leverage}X
        </Col>
      </Row>
      <Row style={{ borderBottom: '1px solid #efefef', padding: '5px 0' }}>
        <Col span={12}>{t('margin')}</Col>
        <Col span={12} style={{ fontWeight: 'bold' }}>
          {margin} {currency}
        </Col>
      </Row>

      <Checkbox
        style={{ marginTop: 10, color: textw }}
        checked={tradeModalStore?.skip}
        onChange={(e) => {
          mutateTradeModalStore({
            ...tradeModalStore,
            skip: e.target.checked,
          });
        }}
      >
        {t('notagain')}
      </Checkbox>
      </div>
    </Modal>
  );
};

export default React.memo(EditCheckPositionModal);
